export default "__VITE_PUBLIC_ASSET__7e2f029e__"